import { render } from "./HeroiconsSolidStop.vue?vue&type=template&id=2a021212"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidStop.vue"]])

export default __exports__